module.exports = "/images/vendor/flag-icon-css/flags/1x1/gd.svg?56fdbab2ad5e961cad7d45359def7915";